document.addEventListener('DOMContentLoaded', function() {

    const buttons = document.querySelectorAll('.filter-btn');

    const cards = document.querySelectorAll('.test-card');



    buttons.forEach(btn => {

        btn.addEventListener('click', () => {

            // Update active state

            buttons.forEach(b => b.classList.remove('active'));

            btn.classList.add('active');
            const filter = btn.getAttribute('data-filter');

            cards.forEach(card => {

                const col = card.closest('.test-col');

                if (!col) return;

                if (filter === 'all' || card.dataset.status === filter) {

                    col.style.display = ''; 

                } else {

                    col.style.display = 'none';

                }

            });

        });

    });




    // Reset Tests Logic

    const resetBtn = document.getElementById('resetTestsBtn');

    if (resetBtn) {

        resetBtn.addEventListener('click', async () => {
            const confirmed = await showModalConfirm({
                title: 'Զրոյացնել արդյունքները', 
                message: 'Վստա՞հ եք, որ ցանկանում եք զրոյացնել ԹԵՍՏԵՐԻ բոլոր արդյունքները։ Այս գործողությունը անդարձելի է։',
                confirmText: 'Զրոյացնել',
                cancelText: 'Չեղարկել'

            });

          
            

            if (!confirmed) return;

            try {
                // Get CSRF token from meta tag or cookie
                const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content ||
                    document.cookie.split('; ').find(row => row.startsWith('_csrf='))?.split('=')[1];
                
                const res = await fetch('/api/v1/user/reset-tests', {
                    method: 'POST',
                    headers: {
                        'x-csrf-token': csrfToken || ''
                    }
                });

                const data = await res.json();

                if(data.status === 'success') {

                    showNotification(data.message || 'Թեստերի արդյունքները զրոյացվեցին', 'success');

                    setTimeout(() => window.location.reload(), 1000);

                } else {

                    showNotification(data.message || 'Սխալ տեղի ունեցավ', 'error');

                }

            } catch(e) {
                showNotification('Սերվերի սխալ', 'error');
            }

        });
    }
});

